<div class="kt-stepper" *ngIf="steps?.length">
  <ng-container *ngFor="let step of steps; let last = last; trackBy: trackByStepId">
    <div class="kt-stepper__step"
      [class.kt-stepper__step--active]="step.state === 'active'"
      [class.kt-stepper__step--completed]="step.state === 'completed'"
      [class.kt-stepper__step--pending]="step.state === 'pending'">
      <div class="kt-stepper__step-pill">
        <div class="kt-stepper__step-icon">
          <span class="material-symbols-outlined kt-stepper__step-check"
            *ngIf="step.state === 'completed'">check</span>
          <span class="kt-stepper__step-number" *ngIf="step.state !== 'completed'">{{ step.stepNumber }}</span>
        </div>
        <span class="kt-stepper__step-name">{{ step.labelKey ? (step.labelKey | translate) : step.label }}</span>
      </div>
      <div class="kt-stepper__step-card-wrap" *ngIf="step.details?.length">
        <div class="kt-stepper__step-card">
          <div class="kt-stepper__step-card-row" *ngFor="let detail of step.details">
            <span class="kt-stepper__step-card-label">
              {{ detail.labelKey ? (detail.labelKey | translate) : detail.label }}
            </span>
            <span class="kt-stepper__step-card-value">
              {{ detail.valueKey ? (detail.valueKey | translate: detail.valueParams) : detail.value }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-stepper__step-connector"
      *ngIf="!last"
      [class.kt-stepper__step-connector--done]="step.state === 'completed'"
      [class.kt-stepper__step-connector--pending]="step.state !== 'completed'"></div>
  </ng-container>
</div>
